import "../css/Loading.css";
import loadingImage from "../img/Loading_icon.gif";
import "../css/FullPageLoadingLayout.css";

function FullPageLoadingLayout(props) {
    return (
        <div className="FullPageLoadingLayout-main-content">
            <div className="FullPageLoadingLayout-inner-content">
               
                <p>{props.messageForLoading} Please Wait   ...</p>
                <img src={loadingImage} />
            </div>
        </div>
    );
}

export default FullPageLoadingLayout;
